<template>
    <div class="h-screen flex flex-col">
        <div class="w-full flex items-center gap-x-2 border-b border-gray-400 py-3 px-6">
            <NuxtLink class="h-fit" :to="`/${route.params.org_slug}`">
                <nuxt-img class="h-5" src="/logo-orange.svg"></nuxt-img>
            </NuxtLink>
            <div class="relative" v-click-outside="() => showSwitchedDropdown = false">
                <button @click.prevent="showSwitchedDropdown = !showSwitchedDropdown" class="text-gray-700 text-sm">
                    {{config.public.isSurveys ? 'Surveys' : 'Forms'}} <font-awesome :icon="['fas', 'caret-down']" />
                </button>
                <div v-show="showSwitchedDropdown" class="absolute top-10 left-0 w-52 bg-white rounded-lg border border-gray-100 drop-shadow-lg px-2 py-2">
                    <NuxtLink :to="`${config.public.boardDomain}/${route.params.org_slug}`">
                      <button class="flex items-center text-gray-700 text-base px-2 py-1 rounded hover:bg-gray-200 w-full mb-2">Board Management</button>
                    </NuxtLink>
                    <div class="flex items-center text-gray-700 text-base px-2 py-1 rounded bg-gray-200 w-full cursor-pointer mb-2">{{config.public.isSurveys ? 'Surveys' : 'Forms'}}</div>
                    <NuxtLink v-if="config.public.isSurveys && (hasStandardProfileDataForms || hasGovernanceForms) && authData?.role === 'admin'"  :to="`${config.public.formDomain}/${route.params.org_slug}`">
                        <button class="flex items-center text-gray-700 text-base px-2 py-1 rounded hover:bg-gray-200 w-full mb-2">Forms</button>
                    </NuxtLink>
                    <NuxtLink v-if="config.public.isForms && hasSurveys"  :to="`${config.public.surveyDomain}/${route.params.org_slug}`">
                        <button class="flex items-center text-gray-700 text-base px-2 py-1 rounded hover:bg-gray-200 w-full mb-2">Surveys</button>
                    </NuxtLink>
                    <NuxtLink v-if="hasPublicPages && authData?.role === 'admin'"  :to="`${config.public.publicPagesDomain}/${route.params.org_slug}/admin`">
                        <button class="flex items-center text-gray-700 text-base px-2 py-1 rounded hover:bg-gray-200 w-full mb-2">Public Site</button>
                    </NuxtLink>
                </div>
            </div> 
            <div class="relative ml-auto flex items-center">
                <div class="flex items-center gap-3 py-1.5 px-4 rounded-lg text-black text-sm font-medium bg-gold mr-3  hidden sm:block" v-if="config.public.isSurveys && onTrial">
                    <span class="font-medium" v-text="trialDaysLeft.message + ' ' + trialDaysLeft.emphasizedText"></span> <a class="underline ml-1 hover:text-primary" :href="`${config.public.boardDomain}/${route.params.org_slug}/subscription/plans`">Upgrade now</a>
                </div>
                <div  v-click-outside="() => showSettingsDropdown = false">
                    <button @click.prevent="() => showSettingsDropdown = !showSettingsDropdown" class="p-2 rounded-lg border border-gray-400 flex items-center gap-x-2">
                        <NuxtImg v-if="authData?.organization?.logo_url" :src="authData?.organization.logo_url" class="h-5" />
                        <Avatar class="w-6 h-6" :url="authData?.user?.profile?.image ? authData?.user?.profile?.imageUrl : ''" />
                    </button>
                    <div v-show="showSettingsDropdown" class="absolute z-50 top-11 right-0 w-[300px] flex flex-col gap-y-2.5 bg-white rounded-lg border border-gray-100 drop-shadow-lg px-2 py-4">
                        <NuxtLink :to="`${config.public.boardDomain}/${route.params.org_slug}/user-settings/profile`">
                            <button class="flex items-center text-left justify-between text-gray-700 text-base px-2 py-1 rounded hover:bg-gray-200 w-full">Boardable user settings <font-awesome :icon="['far', 'arrow-up-right-from-square']" /></button>
                        </NuxtLink>
                        <NuxtLink :to="`${config.public.boardDomain}/${route.params.org_slug}/settings`">
                            <button class="flex items-center text-left justify-between text-gray-700 text-base px-2 py-1 rounded hover:bg-gray-200 w-full">Boardable organization settings <font-awesome :icon="['far', 'arrow-up-right-from-square']" /></button>
                        </NuxtLink>
                        <button @click.prevent="logoutClicked" class="flex items-center text-left justify-between text-gray-700 text-base px-2 py-1 rounded hover:bg-gray-200 w-full">Log out</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-1">
            <slot />
        </div>

        <ModalsContainer />
    </div>
</template>
<script setup lang="ts">
    import Avatar from "~/components/ui/Avatar.vue";
    import Button from "~/components/ui/Button.vue";
    import {ModalsContainer} from "vue-final-modal";
    import {useAuth} from "~/composables/useAuth";

    const route = useRoute()
    const { data: authData, error } = await useFetch(`/api/${route.params.org_slug}/auth`, {
        headers: {
            Accept: 'application/json', // Specify that the client expects JSON
            'X-Api-Request': 'true',
        },
    });

    const logoutClicked = async () => {
        showSettingsDropdown.value = false
        await $fetch(`/api/${route.params.org_slug}/logout`, { method: 'POST' })
        location.reload()
    }
    const showSwitchedDropdown = ref(false)
    const showSettingsDropdown = ref(false)
    const config = useRuntimeConfig();
    const { hasForms, hasSurveys, trialDaysLeft, onTrial, hasPublicPages, hasGovernanceForms, hasStandardProfileDataForms } = useAuth();

</script>
